module.exports = __webpack_public_path__ + "static/media/Muli-ExtraLight.22753ce4.ttf";